import { render, staticRenderFns } from "./SithMesPrdPpOperationList.vue?vue&type=template&id=08b0a800&"
import script from "./SithMesPrdPpOperationList.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdPpOperationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports